export default __webpack_public_path__ + "images/LTR.b4fa572.png";